import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><a parentName="p" {...{
        "href": "../overview.md"
      }}>{`@add-on-hlapi-sdk`}</a>{` / FillableNode`}</p>
    <h1 {...{
      "id": "class-fillablenode"
    }}>{`Class: FillableNode`}</h1>
    <p>{`Base class for a Node that can have its own fill and stroke.`}</p>
    <h2 {...{
      "id": "hierarchy"
    }}>{`Hierarchy`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "StrokableNode.md"
          }}><inlineCode parentName="a">{`StrokableNode`}</inlineCode></a></p>
        <p parentName="li">{`↳ `}<strong parentName="p"><inlineCode parentName="strong">{`FillableNode`}</inlineCode></strong></p>
        <p parentName="li">{`↳↳ `}<a parentName="p" {...{
            "href": "EllipseNode.md"
          }}><inlineCode parentName="a">{`EllipseNode`}</inlineCode></a></p>
        <p parentName="li">{`↳↳ `}<a parentName="p" {...{
            "href": "RectangleNode.md"
          }}><inlineCode parentName="a">{`RectangleNode`}</inlineCode></a></p>
      </li>
    </ul>
    <h2 {...{
      "id": "implements"
    }}>{`Implements`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../interfaces/IFillableNode.md"
        }}><inlineCode parentName="a">{`IFillableNode`}</inlineCode></a></li>
    </ul>
    <h2 {...{
      "id": "table-of-contents"
    }}>{`Table of contents`}</h2>
    <h3 {...{
      "id": "properties"
    }}>{`Properties`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "FillableNode.md#DEFAULT_STROKE_WIDTH"
        }}>{`DEFAULT`}{`_`}{`STROKE`}{`_`}{`WIDTH`}</a></li>
    </ul>
    <h3 {...{
      "id": "accessors"
    }}>{`Accessors`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "FillableNode.md#absoluteRotation"
        }}>{`absoluteRotation`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "FillableNode.md#absoluteTransform"
        }}>{`absoluteTransform`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "FillableNode.md#allChildren"
        }}>{`allChildren`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "FillableNode.md#blendMode"
        }}>{`blendMode`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "FillableNode.md#fills"
        }}>{`fills`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "FillableNode.md#locked"
        }}>{`locked`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "FillableNode.md#opacity"
        }}>{`opacity`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "FillableNode.md#parent"
        }}>{`parent`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "FillableNode.md#relativeRotation"
        }}>{`relativeRotation`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "FillableNode.md#relativeTransform"
        }}>{`relativeTransform`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "FillableNode.md#strokes"
        }}>{`strokes`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "FillableNode.md#translateX"
        }}>{`translateX`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "FillableNode.md#translateY"
        }}>{`translateY`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "FillableNode.md#type"
        }}>{`type`}</a></li>
    </ul>
    <h3 {...{
      "id": "methods"
    }}>{`Methods`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "FillableNode.md#removeFromParent"
        }}>{`removeFromParent`}</a></li>
    </ul>
    <h2 {...{
      "id": "properties-1"
    }}>{`Properties`}</h2>
    <h3 {...{
      "id": "a-iddefault_stroke_width-namedefault_stroke_widtha-default_stroke_width"
    }}><a id="DEFAULT_STROKE_WIDTH" name="DEFAULT_STROKE_WIDTH"></a>{` DEFAULT`}{`_`}{`STROKE`}{`_`}{`WIDTH`}</h3>
    <p>{`▪ `}<inlineCode parentName="p">{`Static`}</inlineCode>{` `}<strong parentName="p">{`DEFAULT`}{`_`}{`STROKE`}{`_`}{`WIDTH`}</strong>{`: `}<inlineCode parentName="p">{`number`}</inlineCode>{` = `}<inlineCode parentName="p">{`20`}</inlineCode></p>
    <h4 {...{
      "id": "inherited-from"
    }}>{`Inherited from`}</h4>
    <p><a parentName="p" {...{
        "href": "StrokableNode.md"
      }}>{`StrokableNode`}</a>{`.`}<a parentName="p" {...{
        "href": "StrokableNode.md#DEFAULT_STROKE_WIDTH"
      }}>{`DEFAULT_STROKE_WIDTH`}</a></p>
    <h2 {...{
      "id": "accessors-1"
    }}>{`Accessors`}</h2>
    <h3 {...{
      "id": "a-idabsoluterotation-nameabsoluterotationa-absoluterotation"
    }}><a id="absoluteRotation" name="absoluteRotation"></a>{` absoluteRotation`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`get`}</inlineCode>{` `}<strong parentName="p">{`absoluteRotation`}</strong>{`(): `}<inlineCode parentName="p">{`number`}</inlineCode></p>
    <p>{`The node's absolute (global) rotation angle in degrees – includes any cumulative rotation from the node's parent containers.`}</p>
    <h4 {...{
      "id": "returns"
    }}>{`Returns`}</h4>
    <p><inlineCode parentName="p">{`number`}</inlineCode></p>
    <h4 {...{
      "id": "inherited-from-1"
    }}>{`Inherited from`}</h4>
    <p>{`StrokableNode.absoluteRotation`}</p>
    <p>{`• `}<inlineCode parentName="p">{`set`}</inlineCode>{` `}<strong parentName="p">{`absoluteRotation`}</strong>{`(`}<inlineCode parentName="p">{`value`}</inlineCode>{`): `}<inlineCode parentName="p">{`void`}</inlineCode></p>
    <h4 {...{
      "id": "parameters"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`value`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "returns-1"
    }}>{`Returns`}</h4>
    <p><inlineCode parentName="p">{`void`}</inlineCode></p>
    <h4 {...{
      "id": "inherited-from-2"
    }}>{`Inherited from`}</h4>
    <p>{`StrokableNode.absoluteRotation`}</p>
    <hr></hr>
    <h3 {...{
      "id": "a-idabsolutetransform-nameabsolutetransforma-absolutetransform"
    }}><a id="absoluteTransform" name="absoluteTransform"></a>{` absoluteTransform`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`get`}</inlineCode>{` `}<strong parentName="p">{`absoluteTransform`}</strong>{`(): `}<a parentName="p" {...{
        "href": "https://glmatrix.net/docs/module-mat2d.html"
      }}><inlineCode parentName="a">{`mat2d`}</inlineCode></a></p>
    <p>{`The node's absolute (global) transform matrix.`}</p>
    <h4 {...{
      "id": "returns-2"
    }}>{`Returns`}</h4>
    <p><a parentName="p" {...{
        "href": "https://glmatrix.net/docs/module-mat2d.html"
      }}><inlineCode parentName="a">{`mat2d`}</inlineCode></a></p>
    <h4 {...{
      "id": "inherited-from-3"
    }}>{`Inherited from`}</h4>
    <p>{`StrokableNode.absoluteTransform`}</p>
    <hr></hr>
    <h3 {...{
      "id": "a-idallchildren-nameallchildrena-allchildren"
    }}><a id="allChildren" name="allChildren"></a>{` allChildren`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`get`}</inlineCode>{` `}<strong parentName="p">{`allChildren`}</strong>{`(): `}<inlineCode parentName="p">{`Readonly`}</inlineCode>{`<`}<inlineCode parentName="p">{`Iterable`}</inlineCode>{`<`}<a parentName="p" {...{
        "href": "Node.md"
      }}><inlineCode parentName="a">{`Node`}</inlineCode></a>{`>`}{`>`}</p>
    <p>{`Returns a read-only list of all children of the node. General-purpose content containers such as ArtboardNode or
GroupNode also provide a mutable `}<a parentName="p" {...{
        "href": "ContainerNode.md#children"
      }}>{`children`}</a>{` list. Other nodes with a more specific structure can
hold children in various discrete "slots"; this `}<inlineCode parentName="p">{`allChildren`}</inlineCode>{` list includes `}<em parentName="p">{`all`}</em>{` such children and reflects their
overall display z-order.`}</p>
    <h4 {...{
      "id": "returns-3"
    }}>{`Returns`}</h4>
    <p><inlineCode parentName="p">{`Readonly`}</inlineCode>{`<`}<inlineCode parentName="p">{`Iterable`}</inlineCode>{`<`}<a parentName="p" {...{
        "href": "Node.md"
      }}><inlineCode parentName="a">{`Node`}</inlineCode></a>{`>`}{`>`}</p>
    <h4 {...{
      "id": "inherited-from-4"
    }}>{`Inherited from`}</h4>
    <p>{`StrokableNode.allChildren`}</p>
    <hr></hr>
    <h3 {...{
      "id": "a-idblendmode-nameblendmodea-blendmode"
    }}><a id="blendMode" name="blendMode"></a>{` blendMode`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`get`}</inlineCode>{` `}<strong parentName="p">{`blendMode`}</strong>{`(): `}<a parentName="p" {...{
        "href": "../enums/BlendModeValue.md"
      }}><inlineCode parentName="a">{`BlendModeValue`}</inlineCode></a></p>
    <p>{`Blend mode determines how a node is composited onto the content below it. The default value is
`}<a parentName="p" {...{
        "href": "../enums/BlendModeValue.md#normal"
      }}>{`normal`}</a>{` for most nodes, and `}<a parentName="p" {...{
        "href": "../enums/BlendModeValue.md#passThrough"
      }}>{`passThrough`}</a>{` for GroupNodes.`}</p>
    <h4 {...{
      "id": "returns-4"
    }}>{`Returns`}</h4>
    <p><a parentName="p" {...{
        "href": "../enums/BlendModeValue.md"
      }}><inlineCode parentName="a">{`BlendModeValue`}</inlineCode></a></p>
    <h4 {...{
      "id": "inherited-from-5"
    }}>{`Inherited from`}</h4>
    <p>{`StrokableNode.blendMode`}</p>
    <p>{`• `}<inlineCode parentName="p">{`set`}</inlineCode>{` `}<strong parentName="p">{`blendMode`}</strong>{`(`}<inlineCode parentName="p">{`value`}</inlineCode>{`): `}<inlineCode parentName="p">{`void`}</inlineCode></p>
    <h4 {...{
      "id": "parameters-1"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`value`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "../enums/BlendModeValue.md"
            }}><inlineCode parentName="a">{`BlendModeValue`}</inlineCode></a></td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "returns-5"
    }}>{`Returns`}</h4>
    <p><inlineCode parentName="p">{`void`}</inlineCode></p>
    <h4 {...{
      "id": "inherited-from-6"
    }}>{`Inherited from`}</h4>
    <p>{`StrokableNode.blendMode`}</p>
    <hr></hr>
    <h3 {...{
      "id": "a-idfills-namefillsa-fills"
    }}><a id="fills" name="fills"></a>{` fills`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`get`}</inlineCode>{` `}<strong parentName="p">{`fills`}</strong>{`(): `}<a parentName="p" {...{
        "href": "ItemList.md"
      }}><inlineCode parentName="a">{`ItemList`}</inlineCode></a>{`<`}<a parentName="p" {...{
        "href": "../interfaces/Fill.md"
      }}><inlineCode parentName="a">{`Fill`}</inlineCode></a>{`>`}</p>
    <p>{`Any fill(s) on the shape. Use the methods on this ItemList object to get, add, and remove fills.`}</p>
    <h4 {...{
      "id": "returns-6"
    }}>{`Returns`}</h4>
    <p><a parentName="p" {...{
        "href": "ItemList.md"
      }}><inlineCode parentName="a">{`ItemList`}</inlineCode></a>{`<`}<a parentName="p" {...{
        "href": "../interfaces/Fill.md"
      }}><inlineCode parentName="a">{`Fill`}</inlineCode></a>{`>`}</p>
    <h4 {...{
      "id": "implementation-of"
    }}>{`Implementation of`}</h4>
    <p><a parentName="p" {...{
        "href": "../interfaces/IFillableNode.md"
      }}>{`IFillableNode`}</a>{`.`}<a parentName="p" {...{
        "href": "../interfaces/IFillableNode.md#fills"
      }}>{`fills`}</a></p>
    <hr></hr>
    <h3 {...{
      "id": "a-idlocked-namelockeda-locked"
    }}><a id="locked" name="locked"></a>{` locked`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`get`}</inlineCode>{` `}<strong parentName="p">{`locked`}</strong>{`(): `}<inlineCode parentName="p">{`boolean`}</inlineCode></p>
    <p>{`The node's lock/unlock state. Locked nodes are excluded from the selection (see `}<a parentName="p" {...{
        "href": "Context.md#selection"
      }}>{`selection`}</a>{`), and
cannot be edited by the user unless they are unlocked first.`}</p>
    <h4 {...{
      "id": "returns-7"
    }}>{`Returns`}</h4>
    <p><inlineCode parentName="p">{`boolean`}</inlineCode></p>
    <h4 {...{
      "id": "inherited-from-7"
    }}>{`Inherited from`}</h4>
    <p>{`StrokableNode.locked`}</p>
    <p>{`• `}<inlineCode parentName="p">{`set`}</inlineCode>{` `}<strong parentName="p">{`locked`}</strong>{`(`}<inlineCode parentName="p">{`locked`}</inlineCode>{`): `}<inlineCode parentName="p">{`void`}</inlineCode></p>
    <h4 {...{
      "id": "parameters-2"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`locked`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "returns-8"
    }}>{`Returns`}</h4>
    <p><inlineCode parentName="p">{`void`}</inlineCode></p>
    <h4 {...{
      "id": "inherited-from-8"
    }}>{`Inherited from`}</h4>
    <p>{`StrokableNode.locked`}</p>
    <hr></hr>
    <h3 {...{
      "id": "a-idopacity-nameopacitya-opacity"
    }}><a id="opacity" name="opacity"></a>{` opacity`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`get`}</inlineCode>{` `}<strong parentName="p">{`opacity`}</strong>{`(): `}<inlineCode parentName="p">{`number`}</inlineCode></p>
    <p>{`The node's opacity, from 0.0 to 1.0`}</p>
    <h4 {...{
      "id": "returns-9"
    }}>{`Returns`}</h4>
    <p><inlineCode parentName="p">{`number`}</inlineCode></p>
    <h4 {...{
      "id": "inherited-from-9"
    }}>{`Inherited from`}</h4>
    <p>{`StrokableNode.opacity`}</p>
    <p>{`• `}<inlineCode parentName="p">{`set`}</inlineCode>{` `}<strong parentName="p">{`opacity`}</strong>{`(`}<inlineCode parentName="p">{`opacity`}</inlineCode>{`): `}<inlineCode parentName="p">{`void`}</inlineCode></p>
    <h4 {...{
      "id": "parameters-3"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`opacity`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "returns-10"
    }}>{`Returns`}</h4>
    <p><inlineCode parentName="p">{`void`}</inlineCode></p>
    <h4 {...{
      "id": "inherited-from-10"
    }}>{`Inherited from`}</h4>
    <p>{`StrokableNode.opacity`}</p>
    <hr></hr>
    <h3 {...{
      "id": "a-idparent-nameparenta-parent"
    }}><a id="parent" name="parent"></a>{` parent`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`get`}</inlineCode>{` `}<strong parentName="p">{`parent`}</strong>{`(): `}<inlineCode parentName="p">{`undefined`}</inlineCode>{` `}{`|`}{` `}<a parentName="p" {...{
        "href": "Node.md"
      }}><inlineCode parentName="a">{`Node`}</inlineCode></a></p>
    <p>{`The node's parent. Undefined if the node is an orphan, or if the node is the artwork root.`}</p>
    <h4 {...{
      "id": "returns-11"
    }}>{`Returns`}</h4>
    <p><inlineCode parentName="p">{`undefined`}</inlineCode>{` `}{`|`}{` `}<a parentName="p" {...{
        "href": "Node.md"
      }}><inlineCode parentName="a">{`Node`}</inlineCode></a></p>
    <h4 {...{
      "id": "inherited-from-11"
    }}>{`Inherited from`}</h4>
    <p>{`StrokableNode.parent`}</p>
    <hr></hr>
    <h3 {...{
      "id": "a-idrelativerotation-namerelativerotationa-relativerotation"
    }}><a id="relativeRotation" name="relativeRotation"></a>{` relativeRotation`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`get`}</inlineCode>{` `}<strong parentName="p">{`relativeRotation`}</strong>{`(): `}<inlineCode parentName="p">{`number`}</inlineCode></p>
    <p>{`The node's local rotation value in degrees, relative to its parent's axes. Modifying this value will also adjust the
node's x & y translation such that the node's center is in the same location after the rotation – i.e. this setter
rotates the node about its bounding box's center, not its origin.`}</p>
    <h4 {...{
      "id": "returns-12"
    }}>{`Returns`}</h4>
    <p><inlineCode parentName="p">{`number`}</inlineCode></p>
    <h4 {...{
      "id": "inherited-from-12"
    }}>{`Inherited from`}</h4>
    <p>{`StrokableNode.relativeRotation`}</p>
    <p>{`• `}<inlineCode parentName="p">{`set`}</inlineCode>{` `}<strong parentName="p">{`relativeRotation`}</strong>{`(`}<inlineCode parentName="p">{`value`}</inlineCode>{`): `}<inlineCode parentName="p">{`void`}</inlineCode></p>
    <h4 {...{
      "id": "parameters-4"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`value`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "returns-13"
    }}>{`Returns`}</h4>
    <p><inlineCode parentName="p">{`void`}</inlineCode></p>
    <h4 {...{
      "id": "inherited-from-13"
    }}>{`Inherited from`}</h4>
    <p>{`StrokableNode.relativeRotation`}</p>
    <hr></hr>
    <h3 {...{
      "id": "a-idrelativetransform-namerelativetransforma-relativetransform"
    }}><a id="relativeTransform" name="relativeTransform"></a>{` relativeTransform`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`get`}</inlineCode>{` `}<strong parentName="p">{`relativeTransform`}</strong>{`(): `}<a parentName="p" {...{
        "href": "https://glmatrix.net/docs/module-mat2d.html"
      }}><inlineCode parentName="a">{`mat2d`}</inlineCode></a></p>
    <p>{`The node's transform matrix relative to its parent.`}</p>
    <h4 {...{
      "id": "returns-14"
    }}>{`Returns`}</h4>
    <p><a parentName="p" {...{
        "href": "https://glmatrix.net/docs/module-mat2d.html"
      }}><inlineCode parentName="a">{`mat2d`}</inlineCode></a></p>
    <h4 {...{
      "id": "inherited-from-14"
    }}>{`Inherited from`}</h4>
    <p>{`StrokableNode.relativeTransform`}</p>
    <hr></hr>
    <h3 {...{
      "id": "a-idstrokes-namestrokesa-strokes"
    }}><a id="strokes" name="strokes"></a>{` strokes`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`get`}</inlineCode>{` `}<strong parentName="p">{`strokes`}</strong>{`(): `}<a parentName="p" {...{
        "href": "ItemList.md"
      }}><inlineCode parentName="a">{`ItemList`}</inlineCode></a>{`<`}<a parentName="p" {...{
        "href": "../interfaces/Stroke.md"
      }}><inlineCode parentName="a">{`Stroke`}</inlineCode></a>{`>`}</p>
    <p>{`Any stroke(s) on the shape. Use the methods on this ItemList object to get, add, and remove strokes.`}</p>
    <h4 {...{
      "id": "returns-15"
    }}>{`Returns`}</h4>
    <p><a parentName="p" {...{
        "href": "ItemList.md"
      }}><inlineCode parentName="a">{`ItemList`}</inlineCode></a>{`<`}<a parentName="p" {...{
        "href": "../interfaces/Stroke.md"
      }}><inlineCode parentName="a">{`Stroke`}</inlineCode></a>{`>`}</p>
    <h4 {...{
      "id": "inherited-from-15"
    }}>{`Inherited from`}</h4>
    <p>{`StrokableNode.strokes`}</p>
    <hr></hr>
    <h3 {...{
      "id": "a-idtranslatex-nametranslatexa-translatex"
    }}><a id="translateX" name="translateX"></a>{` translateX`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`get`}</inlineCode>{` `}<strong parentName="p">{`translateX`}</strong>{`(): `}<inlineCode parentName="p">{`number`}</inlineCode></p>
    <p>{`The translation of the node along its parent's x-axis.`}</p>
    <h4 {...{
      "id": "returns-16"
    }}>{`Returns`}</h4>
    <p><inlineCode parentName="p">{`number`}</inlineCode></p>
    <h4 {...{
      "id": "inherited-from-16"
    }}>{`Inherited from`}</h4>
    <p>{`StrokableNode.translateX`}</p>
    <p>{`• `}<inlineCode parentName="p">{`set`}</inlineCode>{` `}<strong parentName="p">{`translateX`}</strong>{`(`}<inlineCode parentName="p">{`value`}</inlineCode>{`): `}<inlineCode parentName="p">{`void`}</inlineCode></p>
    <h4 {...{
      "id": "parameters-5"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`value`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "returns-17"
    }}>{`Returns`}</h4>
    <p><inlineCode parentName="p">{`void`}</inlineCode></p>
    <h4 {...{
      "id": "inherited-from-17"
    }}>{`Inherited from`}</h4>
    <p>{`StrokableNode.translateX`}</p>
    <hr></hr>
    <h3 {...{
      "id": "a-idtranslatey-nametranslateya-translatey"
    }}><a id="translateY" name="translateY"></a>{` translateY`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`get`}</inlineCode>{` `}<strong parentName="p">{`translateY`}</strong>{`(): `}<inlineCode parentName="p">{`number`}</inlineCode></p>
    <p>{`The translation of the node along its parent's y-axis.`}</p>
    <h4 {...{
      "id": "returns-18"
    }}>{`Returns`}</h4>
    <p><inlineCode parentName="p">{`number`}</inlineCode></p>
    <h4 {...{
      "id": "inherited-from-18"
    }}>{`Inherited from`}</h4>
    <p>{`StrokableNode.translateY`}</p>
    <p>{`• `}<inlineCode parentName="p">{`set`}</inlineCode>{` `}<strong parentName="p">{`translateY`}</strong>{`(`}<inlineCode parentName="p">{`value`}</inlineCode>{`): `}<inlineCode parentName="p">{`void`}</inlineCode></p>
    <h4 {...{
      "id": "parameters-6"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`value`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "returns-19"
    }}>{`Returns`}</h4>
    <p><inlineCode parentName="p">{`void`}</inlineCode></p>
    <h4 {...{
      "id": "inherited-from-19"
    }}>{`Inherited from`}</h4>
    <p>{`StrokableNode.translateY`}</p>
    <hr></hr>
    <h3 {...{
      "id": "a-idtype-nametypea-type"
    }}><a id="type" name="type"></a>{` type`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`get`}</inlineCode>{` `}<strong parentName="p">{`type`}</strong>{`(): `}<a parentName="p" {...{
        "href": "../enums/SceneNodeTypeValueID.md"
      }}><inlineCode parentName="a">{`SceneNodeTypeValueID`}</inlineCode></a></p>
    <p>{`The node's type.`}</p>
    <h4 {...{
      "id": "returns-20"
    }}>{`Returns`}</h4>
    <p><a parentName="p" {...{
        "href": "../enums/SceneNodeTypeValueID.md"
      }}><inlineCode parentName="a">{`SceneNodeTypeValueID`}</inlineCode></a></p>
    <h4 {...{
      "id": "inherited-from-20"
    }}>{`Inherited from`}</h4>
    <p>{`StrokableNode.type`}</p>
    <h2 {...{
      "id": "methods-1"
    }}>{`Methods`}</h2>
    <h3 {...{
      "id": "a-idremovefromparent-nameremovefromparenta-removefromparent"
    }}><a id="removeFromParent" name="removeFromParent"></a>{` removeFromParent`}</h3>
    <p>{`▸ `}<strong parentName="p">{`removeFromParent`}</strong>{`(): `}<inlineCode parentName="p">{`void`}</inlineCode></p>
    <p>{`Removes the node from its parent - for a basic ContainerNode, this is equivalent to `}<inlineCode parentName="p">{`node.parent.children.remove(node)`}</inlineCode>{`.
For nodes with other slots, removes the child from whichever slot it resides in, if possible. Throws if the slot does
not support removal. Also throws if node is the artwork root. No-op if node is already an orphan.`}</p>
    <h4 {...{
      "id": "returns-21"
    }}>{`Returns`}</h4>
    <p><inlineCode parentName="p">{`void`}</inlineCode></p>
    <h4 {...{
      "id": "inherited-from-21"
    }}>{`Inherited from`}</h4>
    <p><a parentName="p" {...{
        "href": "StrokableNode.md"
      }}>{`StrokableNode`}</a>{`.`}<a parentName="p" {...{
        "href": "StrokableNode.md#removeFromParent"
      }}>{`removeFromParent`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      